import { createContext } from 'react';

const StaticContent = createContext({});

export default StaticContent;
